<template>
	<div>
		<!-- <v-dialog v-model="dialog_field" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition"> -->

        	<v-card flat>

        	  	<v-card-text full-height nopadding grey-back>
        	  		<v-form data-vv-scope="fields" full-width data-no-translate>

        	  			<v-layout row wrap padding-top-bottom-ten white-background>
        	  				<div full-width v-for="(item, index) in dynamicFields.items" :key="index">
        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='text'">
        	  					  	<v-text-field  
        	  					  		:label="item.displayName" 
        	  					  		type="text" 
        	  					  		v-model="item.value" 
        	  					  		placeholder=" " 
        	  					  		v-validate="item.isRequired ? 'required|max:'+item.additionalData.maxLength : 'max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
					               	</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='pincode'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="number" 
        	  							v-model.number="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|max'+item.additionalData.maxLength : 'max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  								
        	  						</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='mobileNumber'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="tel" 
        	  							v-model.number="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|max:'+item.additionalData.maxLength : 'max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  								
        	  						</v-text-field>
        	  					</v-flex>

								<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='email'">
									<v-text-field  
										:label="item.displayName" 
										type="email" 
										v-model="item.value" 
										placeholder=" "
										v-validate="item.isRequired ? 'required|email|max:'+item.additionalData.maxLength : 'email|max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
									</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='dateTime'" @click="openDatePicker('dynamicItemFieldDate-fid-'+item.fieldId, item.value)">

        	  						<v-text-field  
        	  							readonly
        	  							append-icon="arrow_drop_down"
        	  							:label="item.displayName"
        	  							:value="fn_formatDate(item.value)"
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required' : ''" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  						</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='longText'">
        	  						<v-textarea  rows="2" 
        	  							:label="item.displayName" 
        	  							v-model="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|max:'+item.additionalData.maxLength : 'max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  						</v-textarea>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='number'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="number" 
        	  							v-model.number="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|numeric|max:'+item.additionalData.maxLength : 'numeric|max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  						</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='decimal'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="number" 
        	  							v-model.number="item.value"
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|decimal:2|max:'+item.additionalData.maxLength : 'decimal:2|max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  								
        	  						</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='choice'">

        	  						<v-select
							          :items="item.additionalData.choices"
							          :label="item.displayName"
									  clearable
									  placeholder=" "
							          v-model="item.value"
							        ></v-select>

							        <span class="error--text font-small" v-show="errors.has('fields.'+item.displayName) && !item.value">
								    	{{ errors.first('fields.'+item.displayName) }}
								    </span>

        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='yes/no'">
        	  						<v-checkbox 
        	  							:label="item.displayName" 
        	  							right-align-checkbox 
        	  							v-model="item.value" 
        	  							v-validate="item.isRequired ? 'required' : ''" 
        	  							:data-vv-name="item.displayName"
        	  							@change="fn_updateCheckBoxValue(item)">
        	  						</v-checkbox>

        	  						<span class="error--text font-small" v-show="errors.has('fields.'+item.displayName) && !item.value">
        	  							{{ errors.first('fields.'+item.displayName) }}
        	  						</span>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='code'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="text" 
        	  							v-model="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required' : ''" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  						</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='linkedItem'" @click="fn_openListItems(item.listItemId, item.value, item.listId, item.listName, item.fieldId)">
									<!-- {{ item }} -->
        	  						<v-text-field  
						               	readonly
						               	v-model="item.value" 
						               	:label="item.displayName" 
						               	placeholder=" " 
						               	append-icon="arrow_drop_down"
						               	:onUpdate="fn_updateLinkedItem"
						               	:ref="fn_getRef('ref_componentDynamicFields_linkedItem-fid-', item.fieldId)"
						               	v-validate="item.isRequired ? 'required' : ''" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
					               </v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='accountItem'" @click="fn_openAccountLedgers(item.accountLedgerId, item.value, item.accountGroupId, item.accountGroupName, item.fieldId)">
        	  						<v-text-field  
						               	readonly
						               	v-model="item.value" 
						               	:label="item.displayName" 
						               	placeholder=" " 
						               	append-icon="arrow_drop_down"
						               	:onUpdate="fn_updateAccountLedger"
						               	:ref="fn_getRef('ref_componentDynamicFields_accountLedger-fid-', item.fieldId)"
						               	v-validate="item.isRequired ? 'required' : ''" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
					               </v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='phoneNumber'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="tel" 
        	  							v-model.number="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|max:'+item.additionalData.maxLength : 'max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  						</v-text-field>
        	  					</v-flex>
        	  				</div>
        	  			</v-layout>
						
        	  		</v-form>
        	  		
        	  	</v-card-text>
	        </v-card>	
      	<!-- </v-dialog> -->
	</div>
</template>	 	

<script>
const accountGroupIds = require('../../config.js').configs.accountGroupIds;
const fieldIds = require('../../config.js').configs.fieldIds;

export default{
	props:['saveFields', 'openAccountLedgers', 'openListItems', 'openDatePicker', 'saveItemFields', 'dynamicFields'],
	data(){	
		return{
			dialog_field: false,
			dynamicFieldDate:null
		}
	},
	methods:{
		openDialogWeb: function () {
			this.dialog_field = true;
		},
		closeDialogWeb: function () {
			this.dialog_field = false;
		},
		fn_getRef: function(ref, fieldId){
			return ref + fieldId;
		},
		fn_openAccountLedgers: function (id, name, accountGroupId, accountGroupName, fieldId) {
			if(fieldIds.transporterName.id == fieldId){
				this.dynamicFields.accountGroupId = accountGroupIds.transporter.id;
				this.dynamicFields.accountGroupName = accountGroupIds.transporter.name;	
			}
			else{
				this.dynamicFields.accountGroupId = accountGroupId;
				this.dynamicFields.accountGroupName = accountGroupName;	
			}

			this.dynamicFields.ref = 'ref_componentDynamicFields_accountLedger-fid-'+fieldId;
			
			let accountGroups = [];
			accountGroups.push(this.dynamicFields.accountGroupId);
			this.openAccountLedgers('android', 'AccountLedgers', 'ref_componentDynamicFields_accountLedger-fid-'+fieldId, id, name, accountGroups);

		},
		fn_openListItems: function (id, name, listId, listName, fieldId) {
			this.dynamicFields.ref = 'ref_componentDynamicFields_accountLedger-fid-'+fieldId;
			this.openListItems('android', 'ListItems', 'ref_componentDynamicFields_linkedItem-fid-'+fieldId, id, name, listId, listName);
		},
		fn_updateAccountLedger: function (selectedValueId, selectedValueName, isRemoved, ref, accountGroupId) {
			// accountGroupId coming from new ledger making directly via dialog
			if(this.dynamicFields.accountGroupId == accountGroupIds.transporter.id && (accountGroupId && accountGroupId != accountGroupIds.transporter.id)){
				this.showToast("Invalid Transporter");
				return;
			}

			let items = this.dynamicFields.items;

			let fieldRef = ref ? ref : this.dynamicFields.ref;

			let fieldId = fieldRef.substring(fieldRef.lastIndexOf('-fid-') + 5);

			for(let i=0; i<items.length; i++){
				let item = items[i];
				if(item.fieldId == fieldId && item.fieldType == 'accountItem'){
					if(!isRemoved){
						item.value = selectedValueName;
						item.accountLedgerId = selectedValueId;
					}
					else{
						item.value = null;
						item.accountLedgerId = null;	
					}
					this.$forceUpdate();
					break;
				}
			}
		},
		fn_updateLinkedItem: function (selectedValueId, selectedValueName, isRemoved, ref) {
			let items = this.dynamicFields.items;

			let fieldRef = ref ? ref : this.dynamicFields.ref;

			let fieldId = fieldRef.substring(fieldRef.lastIndexOf('-fid-') + 5);
			
			for(let i=0; i<items.length; i++){
				let item = items[i];
				if(item.fieldId == fieldId && item.fieldType=='linkedItem'){
					if(!isRemoved){
						item.value = selectedValueName;
						item.listItemId = selectedValueId;
					}
					else{
						item.value = null;
						item.listItemId = null;	
					}
					this.$forceUpdate();
					break;
				}
			}
		},
		fn_updateCheckBoxValue: function(item){
			this.$forceUpdate();
			!item.value ? item.value = null : '';
		},

		fn_checkValidations: function(){
			this.$validator.validateAll('fields').then((result) => {
		        if (result) {
                    return true;
		        	// let emptyFields = true;
		        	// for(let i=0; i<this.dynamicFields.items.length; i++){
		        	// 	if(this.dynamicFields.items[i].value){
		        	// 		emptyFields = false;
		        	// 		break;
		        	// 	}
		        	// }
		        	// // !emptyFields ? this.saveFields(this.dynamicFields) : this.$parent.fn_closeDialog();
					// if(emptyFields){
					// 	this.$parent.fn_closeDialog();
					// }
					// else{
					// 	if(this.dynamicFields.isItemDetails){
					// 		this.saveItemFields(this.dynamicFields);
					// 	}
					// 	else{
					// 		this.saveFields(this.dynamicFields);
					// 	}
					// }
		        }
                else{
                    return false;
                }
		    });
		},
		fn_updateDynamicDate: function(value, dateType){
			let fieldId = dateType.substring(dateType.lastIndexOf('-fid-') + 5);

			for(let i in this.dynamicFields.items){
				if(this.dynamicFields.items[i].fieldId == fieldId && this.dynamicFields.items[i].fieldType == 'dateTime'){
					// this.$set(this.dynamicFields.items[i], 'value', value);
					let date = this.$root.fn_getLocalDateFormat(value);
					this.$set(this.dynamicFields.items[i], 'value', date);
					this.$forceUpdate();
					break;
				}
			}
		},
		fn_formatDate: function(val){
			let date = val ? new Date(val) : null;
			return date ? this.$moment(date).format('DD-MMM-YYYY') : null;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/component_dynamic_fields.vue